import React, { useEffect, useState } from 'react'
import '../../../css/Style/LandingPage/PopularDestination.css'
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios'
import {BASE_URL} from "../../pages/constant";
import api from "../../pages/api";
import {getAllCategoryData} from "../../util/GetAllCategory";
import {getAllTrips} from "../../util/FetchTrips";
import {getHomeCategoryData} from "../../util/HomeCategory";

const PopularDestination = () => {
    const navigate = useNavigate();

    const [popularDestination, setPopularDestination] = useState(null)
    const [allCategory, setAllCategory] = useState([])
    // get All Selected Home Page Category
    const getSelectedHomeCategory = () => {
        getHomeCategoryData(BASE_URL).then((res) => {
            setPopularDestination(res[0]?.popularCategory)
        })
    }

    // get all category
    const getAllCategory = async () => {
        await getAllCategoryData(BASE_URL).then((res) => {
            if (res) {
                setAllCategory(res)
            }
        }).catch((err) => {
            console.log(err);
        });
    }

    const image1 = allCategory?.find(obj => obj?.name === (popularDestination && popularDestination[0]));
    const image2 = allCategory?.find(obj => obj?.name === (popularDestination && popularDestination[1]));
    const image3 = allCategory?.find(obj => obj?.name === (popularDestination && popularDestination[2]));
    const image4 = allCategory?.find(obj => obj?.name === (popularDestination && popularDestination[3]));
    const image5 = allCategory?.find(obj => obj?.name === (popularDestination && popularDestination[4]));

    useEffect(() => {
        getSelectedHomeCategory();
        getAllCategory();
        // eslint-disable-next-line
    }, [])

    const onClick = (value)=>{
        return navigate(`/customised/${popularDestination && popularDestination[value].toLowerCase().replace(/\s+/g, '-')}`)
    }

    return (
        popularDestination &&
        <div className='Mon_font container my-5 customised-container d-block m-auto text-center'>
            <h2 className='fw-bolder m-0'>Customize Your Trip</h2>
            <div className='hr-line mb-3'></div>
            <p>Your Dates + Your Group + Your Budget</p>
            <div className="customised">
                <div className="item-30" onClick={() => onClick(0)} style={{ background: `url(${image1?.url})` }}>
                    <div className="text-center text-white mb-2 fw-bold">
                        <h5>{popularDestination && popularDestination[0]}</h5>
                    </div>
                </div>
                <div className="item-30" onClick={() => onClick(1)} style={{ background: `url(${image2?.url})` }}>
                    <div className="text-center text-white mb-2 fw-bold">
                        <h5>{popularDestination && popularDestination[1]}</h5>
                    </div>
                </div>
                <div className="item-30" onClick={() => onClick(2)} style={{ background: `url(${image3?.url})` }}>
                    <div className="text-center text-white mb-2 fw-bold">
                        <h5>{popularDestination && popularDestination[2]}</h5>
                    </div>
                </div>
                <div className="item-30" onClick={() => onClick(3)} style={{ background: `url(${image4?.url})` }}>
                    <div className="text-center text-white mb-2 fw-bold">
                        <h5>{popularDestination && popularDestination[3]}</h5>
                    </div>
                </div>
                <div className="item-70" onClick={() => onClick(4)} style={{ background: `url(${image5?.url})` }}>
                    <div className="text-center text-white mb-2 fw-bold">
                        <h5>{popularDestination && popularDestination[4]}</h5>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PopularDestination
